import { mutate } from "swr";
import { setIsLoading } from "../store";

export function normalizeNumericString(value?: string): string {
    const trimmed = value?.trim() ?? "";
    return trimmed && !Number.isNaN(Number(trimmed))
        ? String(Number(trimmed))
        : "";
}

export async function editVateRate(
    franchiseID: any,
    updatedRows: any,
    dataIsUpdated: boolean | number,
    setDataIsUpdated: Function,
    setIsAddVatRateClicked: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["tva"],
            data: updatedRows,
        }),
    };
    try {
        const data = await fetchGlobal<any>(apiUrl, requestOptions);

        if (data.error) {
            throw Error("error");
        } else {
            setDataIsUpdated(!dataIsUpdated);
            setIsAddVatRateClicked(false);
        }
        setIsLoading(false);

        mutate(apiUrl, data);
    } catch (e) {
        setIsLoading(false);
    }
}
